// @flow

import ApiObject from '../ApiObject';

import ProAccount from './ProAccount';
import ProRole from './ProRole';
import RestaurantsGroup from '../restaurantsGroup/RestaurantsGroup';

export default class ProDomain extends ApiObject {

  id: string;

  accountId: string;

  roleId: string;

  restaurantsGroupId: string;

  account: ProAccount;

  role: ProRole;

  /**
   * front only.
   */
  restaurantsGroup: RestaurantsGroup;

  postJsonAssignation(data: Object) {
    this.restaurantsGroup = new RestaurantsGroup();
    this.restaurantsGroup.fromJson(data.restaurantsGroup);

    this.role = new ProRole();
    this.role.fromJson(data.role);
  }
}



// WEBPACK FOOTER //
// ./sdk/scripts/entities/security/ProDomain.js